import { JSX } from 'react';

import { OrThreeBlocks } from './or-three-blocks';

import { parseCTACardFromCMS } from '@/lib/contentstack-sdk/utils/parseHelpers';
import { IOrThreeBlocksPropsCMS } from './or-three-blocks.types';

export const OrThreeBlocksCMS = ({
  main_card,
  complementary_cards,
  top_spacing,
  bottom_spacing,
}: IOrThreeBlocksPropsCMS): JSX.Element => {
  const mainCard = parseCTACardFromCMS(main_card[0]);
  const complementaryCards = complementary_cards.map((c) =>
    parseCTACardFromCMS(c),
  );

  return (
    <OrThreeBlocks
      topSpacing={top_spacing?.spacing_value}
      bottomSpacing={bottom_spacing?.spacing_value}
      topDivider={top_spacing?.divider}
      bottomDivider={bottom_spacing?.divider}
      mainCard={mainCard}
      complementaryCards={complementaryCards}
    />
  );
};
